<template>
  <KernelContainer screen>
    <AppHeader class="breakout" />
    <slot />
  </KernelContainer>
</template>

<script setup>
definePageMeta({
  middleware: 'activate-page',
})
</script>

<style scoped>
.navbar {
  margin-block-end: 1.25rem;
}

.container {
  padding-block-start: 0;
}
</style>
